import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-logged-in-info-card',
  templateUrl: './not-logged-in-info-card.component.html',
  styleUrls: ['./not-logged-in-info-card.component.scss'],
})
export class NotLoggedInInfoCardComponent implements OnInit {
  screenWidth: number = window.innerWidth;

  constructor() { }

  get isExpandable(): boolean {
    return this.screenWidth < 700;
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenWidth = window.innerWidth;
  }

  ngOnInit() {}

}
